import React from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const CommonHeader = ({ 
  title, 
  icon, 
  subtitle, 
  quote, 
  onBack, 
  theme,
  showBackButton = true 
}) => {
  const styles = {
    container: {
      marginBottom: '2rem',
    },
    headerCard: {
      background: `linear-gradient(135deg, ${theme?.primary?.blue?.[500]} 0%, ${theme?.primary?.blue?.[500]} 100%)`,
      borderRadius: '1.25rem',
      padding: '2rem',
      boxShadow: theme?.shadows?.lg,
      color: 'white',
      position: 'relative',
      overflow: 'hidden',
    },
    backgroundPattern: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      opacity: 0.1,
      backgroundImage: `
        radial-gradient(circle at 20% 80%, transparent 40%, rgba(255,255,255,0.1) 40.5%, rgba(255,255,255,0.1) 60%, transparent 60.5%),
        radial-gradient(circle at 80% 20%, transparent 40%, rgba(255,255,255,0.1) 40.5%, rgba(255,255,255,0.1) 60%, transparent 60.5%),
        radial-gradient(circle at 50% 50%, transparent 40%, rgba(255,255,255,0.1) 40.5%, rgba(255,255,255,0.1) 60%, transparent 60.5%)
      `,
    },
    navigation: {
      display: 'flex',
      alignItems: 'center',
      gap: '1rem',
      marginBottom: '1rem',
    },
    backButton: {
      width: '2.5rem',
      height: '2.5rem',
      borderRadius: '0.75rem',
      background: 'rgba(255, 255, 255, 0.2)',
      border: '1px solid rgba(255, 255, 255, 0.3)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      color: 'white',
    },
    backButtonHover: {
      background: 'rgba(255, 255, 255, 0.3)',
      transform: 'translateX(-3px)',
    },
    content: {
      position: 'relative',
      zIndex: 1,
    },
    titleRow: {
      display: 'flex',
      alignItems: 'center',
      gap: '1rem',
      marginBottom: '0.5rem',
    },
    icon: {
      width: '2.5rem',
      height: '2.5rem',
      fontSize: '2rem',
      opacity: 0.9,
    },
    title: {
      fontSize: '2rem',
      fontWeight: '700',
      margin: 0,
    },
    subtitle: {
      fontSize: '1rem',
      opacity: 0.9,
      marginLeft: '3.5rem',
    },
    quote: {
      position: 'absolute',
      bottom: '1rem',
      right: '2rem',
      fontStyle: 'italic',
      fontSize: '0.875rem',
      opacity: 0.8,
      maxWidth: '300px',
      textAlign: 'right',
    },
  };

  return (
    <div style={styles.container}>
      <motion.div
        style={styles.headerCard}
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div style={styles.backgroundPattern} />
        
        <div style={styles.content}>
          <div style={styles.titleRow}>
            {showBackButton && onBack ? (
              <motion.button
                style={styles.backButton}
                whileHover={{
                  backgroundColor: 'rgba(255, 255, 255, 0.3)',
                  x: -3
                }}
                whileTap={{ scale: 0.95 }}
                onClick={onBack}
              >
                <FontAwesomeIcon icon={faArrowLeft} />
              </motion.button>
            ) : (
              icon && <FontAwesomeIcon icon={icon} style={styles.icon} />
            )}
            <h1 style={styles.title}>{title}</h1>
          </div>
          
          {subtitle && (
            <p style={styles.subtitle}>{subtitle}</p>
          )}
        </div>
        
        {quote && (
          <p style={styles.quote}>{quote}</p>
        )}
      </motion.div>
    </div>
  );
};

export default CommonHeader; 